import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { ListItem, ListItemText } from '@material-ui/core/List'
import Collapse from '@material-ui/core/Collapse'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ServiceLayersList from './ServiceLayersList'
import ServiceLocationsList from './ServiceLocationsList'

const styles = theme => ({
  card: {
    maxWidth: 400,
    marginTop: 5
  },
  item: {
    paddingTop: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    paddingRight: '0px'
  },
  media: {
    height: 194
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  flexGrow: {
    flex: '1 1 auto'
  }
})

class ServiceDrawerListItem extends Component {
  state = {
    expanded: false
  }

  handleExpandClicked = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }

  handleServiceClicked = () => {
    const { service, serviceCardChanged } = this.props
    serviceCardChanged(service)
  }

  render () {
    const {
      classes,
      handleLocationClicked,
      handleLayerToggled,
      layersRendered,
      service
    } = this.props
    const { expanded } = this.state
    return (
      <div>
        <ListItem className={classes.item}>
          <ListItemText
            primary={service.label || service.name}
            onClick={this.handleServiceClicked}
          />
          <IconButton
            className={classes.expand}
            onClick={this.handleExpandClicked}
            aria-expanded={expanded}
            aria-label='Show more'
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </ListItem>

        <Collapse in={expanded} unmountOnExit>
          <ServiceLayersList
            service={service}
            handleLayerToggled={handleLayerToggled}
            layersRendered={layersRendered}
          />
          <Divider />
          <ServiceLocationsList
            service={service}
            handleLocationClicked={handleLocationClicked}
          />
        </Collapse>
      </div>
    )
  }
}

export default withStyles(styles)(ServiceDrawerListItem)



// WEBPACK FOOTER //
// ./src/components/ServiceDrawerListItem.js